<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('Sales installments') }}
        </h4>
        <router-link
          :to="'/salesInstallments/create?customer_id=' + $route.params.id"
          class="btn btn-sm btn-primary"
          v-if="$parent.item.stat == 1 && $checkRole('sales_payments_add')"
        >
          <i class="fas fa-plus"></i>
          {{ $t('Addition') }}
        </router-link>
      </div>
      <indexTable
        :searchText="$t('Find an installment')"
        :withoutCard="true"
        :emptyTableText="$parent.$t('There are no sales installments')"
        :filter="{ customer_id: $route.params.id }"
        :emptyTableSubText="$parent.$t('Try adding some items to the table and try again')"
        :cloumns="[
          {
            column: 'code',
            title: $t('Payment'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'customer_id',
            title: $t('Customer name'),
            type: 'link',
            to: 'customer',
            sort: true,
            link: true
          },
          {
            column: 'created_date',
            title: $t('Registration date'),
            type: 'text',
            sort: true
          },
          {
            column: 'date',
            title: $parent.$t('Payment date'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: $parent.$t('Thats about'),
            type: 'text',
            sort: true
          },
          {
            column: 'total',
            title: $parent.$t('Amount'),
            type: 'text',
            sort: true
          },
          {
            column: 'paid',
            title: $t('Paid'),
            type: 'text',
            sort: true
          },
          {
            column: 'stat',
            title: $t('Active'),
            type: 'status',
            sort: true,
            values: [
              {
                title: $t('Waiting'),
                value: 1,
                color: 'info'
              },
              {
                title: $t('Driven'),
                value: 0,
                color: 'success'
              }
            ]
          },
          {
            column: 'options',
            title: $parent.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role: $checkRole('sales_cheques_edit')
              },
              {
                name: 'link',
                role: $checkRole('sales_cheques_edit'),
                title: $t('Add payment'),
                icon: 'dollar-sign',
                link: '/salesInstallmentsPayments/create/'
              },
              {
                name: 'delete',
                role: $checkRole('sales_cheques_delete')
              }
            ]
          }
        ]"
        :deleteText="{
          attention: $parent.$t('Attention'),
          areYouReallySureToDeleteTheItem: $parent.$t('Are you really sure to delete the item'),
          close: $parent.$t('Close'),
          confirm: $parent.$t('Confirm'),
          loading: $parent.$t('Loading')
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/salesInstallments'
    }
  },
  components: {
    indexTable
  }
}
</script>
